import { render, staticRenderFns } from "./EditFaq.vue?vue&type=template&id=3ba05da2&scoped=true&"
import script from "./EditFaq.vue?vue&type=script&lang=js&"
export * from "./EditFaq.vue?vue&type=script&lang=js&"
import style0 from "./EditFaq.vue?vue&type=style&index=0&id=3ba05da2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba05da2",
  null
  
)

export default component.exports